import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import CascadiaCodeRegular from "./CascadiaCode-Regular.woff2";

export const CascadiaFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: CascadiaCodeRegular,
  },
];
